<template>
  <div class="template-detail-dialog" v-if="surveyTableDetail">
    <el-dialog title="模板详情" :visible.sync="syncVisible" width="750px">
      <!-- <div class="table">
        <el-form :model="surveyTableDetail" ref="ruleForm" label-width="100px">
          <el-form-item label="名称" prop="formName">
            <el-input v-model="surveyTableDetail.formName" :disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item label="说明" prop="description">
            <el-input type="textarea" v-model="surveyTableDetail.description" :disabled="disabled"></el-input>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
        <el-form v-for="(item, index) in surveyTableDetail.surveyQuestionsList" :key="index" label-width="100px">
          <el-form-item :label="index + 1 + '.问题标题'" :label-position="labelPosition" required>
            <el-input v-model="item.title" :disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item label="说明">
            <el-input type="textarea" v-model="item.description" :disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item label="顺序" :label-position="labelPosition" required>
            <el-input v-model="item.sequence" type="number" :disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item label="是否必填" :label-position="labelPosition">
            <el-switch v-model="item.isRequiredStatus" :disabled="disabled"
              @change="isRequiredChange($event, item)"></el-switch>
          </el-form-item>
          <el-form-item label="回答类型" required>
            <el-select v-model="item.problemType" placeholder="请选择类型" :disabled="disabled">
              <el-option v-for="(item, index) in questionTypeList" :key="index" :label="item.dictLabel"
                :value="item.dictValue"></el-option>
            </el-select>
          </el-form-item>
          <div class="option-list" v-if="item.problemType !== '' &&
            item.problemType !== '4' &&
            item.problemType !== '5'
          ">
            <div class="option-item" v-for="(oItem, oIndex) in item.surveyOptionsList" :key="oIndex">
              {{ oIndex + 1 }}.
              <el-input v-model="oItem.optionContent" type="optionContent" :disabled="disabled" placeholder="请输入选项名称" />
            </div>
          </div>
          <el-divider></el-divider>
        </el-form>
      </div> -->
      <div class="table" v-if="surveyTableDetail">
        <div class="title">
          {{ surveyTableDetail.formName }}
        </div>
        <!-- <div class="end-time">结束时间：{{ ruleForm.endTime }}</div> -->
        <div class="description" v-html="surveyTableDetail.description"></div>
        <el-divider></el-divider>
        <el-form>
          <el-form-item v-for="(item, index) in surveyTableDetail.surveyQuestionsList" :key="index"
            :label="index + 1 + '.' + item.title" :label-position="labelPosition"
            :required="item.isRequired == '1' ? true : false" style="text-align: left">
            <div class="item-description">{{ item.description }}</div>
            <el-radio-group v-model="item.val" v-if="item.problemType == '1'" :disabled="disabled">
              <el-radio v-for="(rItem, rIndex) in item.surveyOptionsList" :key="rIndex"
                :label="rItem.optionContent"></el-radio>
            </el-radio-group>
            <el-checkbox-group v-model="item.checkedVal" v-if="item.problemType == '2'" :disabled="disabled">
              <el-checkbox v-for="(eItem, eIndex) in item.surveyOptionsList" :key="eIndex" :label="eItem.optionContent"
                :name="eItem.optionContent"></el-checkbox>
            </el-checkbox-group>
            <el-select v-model="item.val" placeholder="请选择" v-if="item.problemType == '3'" :disabled="disabled">
              <el-option v-for="(oItem, oIndex) in item.surveyOptionsList" :key="oIndex" :label="oItem.optionContent"
                :value="oItem.optionContent"></el-option>
            </el-select>
            <el-input v-if="item.problemType == '4'" v-model="item.val" :disabled="disabled"></el-input>
            <el-upload v-if="item.problemType == '5'" action="#" list-type="picture-card" :disabled="true">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["templateDetailDialogShow", "surveyTableDetail", "questionTypeList"],
  data() {
    return {
      // 标签位置
      labelPosition: "left",
      disabled: false
    };
  },
  computed: {
    syncVisible: {
      get() {
        return this.templateDetailDialogShow;
      },
      set(val) {
        this.$emit('update:templateDetailDialogShow', val);
      }
    }
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
@import "./templateDetailDialog.scss";
</style>